import React, { useRef, useState, useEffect } from "react";
import axios from "axios";
import { message, Form, Input, Button, Alert } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { HeaderHome } from "./HeaderHome";
import { Footer } from "./Footer";
import Modal from "react-modal";
import Select from "react-select";
import Slider from "react-slick";
import "./assets/ohs/newstyle.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ReactDialogBox } from "react-js-dialog-box";
import { FaFilePdf } from "react-icons/fa";
import generatePDF from "./Elearningcourseuser/PDFscore";
export const Ohs = () => {
  const inputFileRef = useRef(null);
  const [strokeDashArray_less, setstrokeDashArray_less] = useState("186.56");
  const [isComplete, setComplete] = useState([]);
  const [pdfname, setpdfname] = useState("");
  const [pdfdate, setpdfdate] = useState("");
  const [scoreCard, setscoreCard] = useState("");
  const currentYear = new Date().getFullYear();
  const [opendialog, setopendialog] = useState(false);
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("home-tab");
  const [getincidentData, setgetincidentData] = useState([]);
  const [getincidentDataLength, setgetincidentDataLength] = useState([]);
  const [getneartData, setgetnearData] = useState([]);
  const [getnearDataLength, setgetnearDataLength] = useState([]);
  const [issetgetLocations, setgetLocations] = useState([]);
  const [issetgetLocationsingle, setgetLocationsingle] = useState("");
  const [isgetallhazardl, setisgetallhazardl] = useState(0);
  const [isgetallhazard, setisgetallhazard] = useState([]);
  const [docscategory, setdocscategory] = useState([]);
  const [iscategoryvl, setcategoryvl] = useState("");
  const [diss, setdiss] = useState(false);
  const [name_9, setname_9] = useState("");
  const [PdfcardImg, setPdfcardImg] = useState("");
  const [issetgetalldocuments, setgetalldocuments] = useState([]);
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const [openDropdownIndexMiss, setOpenDropdownIndexMiss] = useState(null);
  const [openDropdownIndexIncident, setOpenDropdownIndexIncident] =
    useState(null);
  const [openDropdownIndexeditMiss, setOpenDropdownIndexeditMiss] =
    useState(null);
  const [openDropdownIndexeditIncident, setOpenDropdownIndexeditIncident] =
    useState(null);
  const [isModalOpenDoc, setIsModalOpenDoc] = useState(false);
  const [openDropdownIndexedit, setOpenDropdownIndexedit] = useState(null);
  const [fileshow, setfilename] = useState("");
  const [docs_s, setdocs_s] = useState(false);
  const [issetiselarning, setiselarning] = useState([]);
  const [courseOverdue, setcourseOverdue] = useState([]);
  const [courseUpcoming, setcourseUpcoming] = useState([]);
  const [courseUpcomingd, setcourseUpcomingd] = useState([]);
  const [courseComplete, setcourseComplete] = useState([]);
  const changeFavicon = (url) => {
    const favicon = document.querySelector('link[rel="icon"]');
    if (favicon) {
      favicon.href = url;
    }
  };

  useEffect(() => {
    changeFavicon(require("./assets/admin/images/f-icon.png"));
    const userStr = JSON.parse(localStorage.getItem("users"));
    if (userStr === null) {
      window.location.href = "/login";
    }
    document.title = "OHS Page";
    const storedUserSearch = localStorage.getItem("userSearch");
    const userSearch = JSON.parse(storedUserSearch);

    if (userSearch === null) {
      var search = "";
    } else {
      var search = userSearch.search;
    }
    let formdata = {
      user_id: userStr[0].id,
      search: search,
    };

    const options = {
      day: "2-digit",
      month: "long", // Change to "long" for full month name
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZone: "Australia/Perth",
    };

    const date = new Date();
    const formattedDate = date.toLocaleDateString("en-GB", options);
    console.log("time");
    console.log(formattedDate);

    axios
      .post("https://jlmining.app/getassignCourseOverdue", formdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setcourseOverdue(res.data.results.length);
      })
      .catch((err) => { });
    axios
      .post("https://jlmining.app/getassignCourseUpcoming", formdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setcourseUpcoming(res.data.mainarrray.length);
        setcourseUpcomingd(res.data.mainarrray);
      })
      .catch((err) => { });
    axios
      .post("https://jlmining.app/getassignCourseComplete", formdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        //console.log("cs");
        // console.log(res.data.results);
        setcourseComplete(res.data.results.length);
        //setcourseComplete(res.data.results);
      })
      .catch((err) => { });

    axios
      .post("https://jlmining.app/getalldocuments", formdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setgetalldocuments(res.data.results);
      })
      .catch((err) => { });
    axios
      .post("https://jlmining.app/getlocationohs", formdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.data.results.length > 0) {
          const options = res.data.results.map((item) => ({
            value: item.location_name,
            label: item.location_name,
          }));
          setgetLocations(options);
        }
      })
      .catch((err) => { });
    axios
      .post("https://jlmining.app/getAllincidentdata", formdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setgetincidentDataLength(res.data.results.length);
        if (res.data.results.length > 0) {
          var indata = res.data.results;
          setgetincidentData(indata);
        }
      })
      .catch((err) => { });
    axios
      .post("https://jlmining.app/getAllneardata", formdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setgetnearDataLength(res.data.results.length);
        if (res.data.results.length > 0) {
          var indata = res.data.results;
          setgetnearData(indata);
        }
      })
      .catch((err) => { });
    axios
      .post("https://jlmining.app/getAllreporthazard", formdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setisgetallhazardl(res.data.results.length);

        setisgetallhazard(res.data.results);
      })
      .catch((err) => { });
    axios
      .post("https://jlmining.app/getallelearning", formdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setiselarning(res.data.results);
      })
      .catch((err) => { });
    const options_category = [
      { value: "CHECKLIST", label: "Checklist" },
      { value: "FIRE_SAFETY", label: "Fire Safety" },
      { value: "FIRST_AID", label: "First Aid" },
      { value: "INCIDENT_RECORD", label: "Incident Record" },
      { value: "METHOD_STATEMENT", label: "Method Statement" },
      { value: "MISC", label: "Misc" },
      { value: "PHOTOGRAPH", label: "Photograph" },
      { value: "PROCEDURE", label: "Procedure" },
      { value: "REPORT", label: "Report" },
      { value: "RESPONSIBILITY", label: "Responsibility" },
      { value: "RISK_ASSESSMENT", label: "Risk Assessment" },
      { value: "SAFETY_DATA_SHEET", label: "Safety Data Sheet" },
      { value: "SAFETY_RECORD", label: "Safety Record" },
      { value: "SAFE_WORK_PROCEDURE", label: "Safe Work Procedure" },
      { value: "TOOLBOX_TALK", label: "Tool-box Talk" },
    ];
    setdocscategory(options_category);
    if (scoreCard != "") {
      pdfdataget();
      setscoreCard("");
    }
    const totals = courseUpcoming;

    if (totals === 16) {
      setstrokeDashArray_less("370.56");
    } else {
      const t = parseFloat(totals * 11);
      const tt = parseFloat(t + 0.56);
      const t_t = 186;
      const ttt = t_t + tt;
      //console.log("asj");
      //console.log(ttt);

      setstrokeDashArray_less(ttt.toString()); // Ensure it's a string
    }
  }, [
    scoreCard,
    PdfcardImg,
    name_9,
    pdfname,
    pdfdate,
    courseComplete,
    courseUpcoming,
  ]);
  const imgBase64 =
    "data:image/png;base64,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";
  const handactivetabsection = (event, tabId) => {
    // Prevent default action of button click
    event.preventDefault();

    // Remove "active" class from all nav links
    document.querySelectorAll(".nav-link").forEach((link) => {
      link.classList.remove("active");
    });

    // Add "active" class to the clicked nav link
    event.target.classList.add("active");

    // Remove "show active" classes from all tab panes
    document.querySelectorAll(".tab-pane").forEach((pane) => {
      pane.classList.remove("show", "active");
    });

    // Add "show active" classes to the clicked tab pane
    const tabPane = document.getElementById(`${tabId}-pane`);
    if (tabPane) {
      tabPane.classList.add("show", "active");
    }

    // Update activeTab state
    setActiveTab(tabId);
  };
  var settings = {
    dots: false,
    infinite: true,
    centerMode: true,
    centerPadding: "40px",
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
  };
  function getdattime(dateString) {
    const options = {
      weekday: "short",
      day: "2-digit",
      month: "short",
      year: "numeric",
    };
    const formattedDate = new Date(dateString).toLocaleString("en-US", options);
    return formattedDate;
  }
  function formatDate_notes(dateString) {
    const options = {
      month: "long",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", options);
  }
  function formatDate_date(dateString) {
    const options = {
      month: "long",
      day: "numeric",
      year: "numeric",
    };
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", options);
  }
  const hazardedit = (index) => {
    setOpenDropdownIndex(index === openDropdownIndex ? null : index);
  };
  const editr = (index) => {
    setOpenDropdownIndexedit(index === openDropdownIndexedit ? null : index);
  };
  const nearmissedit = (index) => {
    setOpenDropdownIndexMiss(index === openDropdownIndexMiss ? null : index);
  };
  const incidentedit = (index) => {
    setOpenDropdownIndexIncident(
      index === openDropdownIndexIncident ? null : index
    );
  };
  const remover = (event, index, code) => {
    const userStr = JSON.parse(localStorage.getItem("users"));
    let fdata = {
      id: event,
      user_id: userStr[0].id,
      code: code,
    };
    axios
      .post("https://jlmining.app/removehazard", fdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        // console.log(res.data.results);

        setOpenDropdownIndexedit(index === openDropdownIndexedit ? null : null);
        setOpenDropdownIndex(index === openDropdownIndex ? null : null);
        setTimeout(() => {
          setisgetallhazardl(res.data.results.length);

          setisgetallhazard(res.data.results);
        }, 500);
      })
      .catch((err) => { });
  };
  const removeIncident = (event, index, code) => {
    const userStr = JSON.parse(localStorage.getItem("users"));
    let fdata = {
      id: event,
      user_id: userStr[0].id,
      code: code,
    };
    axios
      .post("https://jlmining.app/removeIncident", fdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        // console.log(res.data.results);

        setOpenDropdownIndexeditIncident(
          index === openDropdownIndexeditIncident ? null : null
        );
        setOpenDropdownIndexIncident(
          index === openDropdownIndexIncident ? null : null
        );
        setTimeout(() => {
          setgetincidentDataLength(res.data.results.length);

          setgetincidentData(res.data.results);
        }, 500);
      })
      .catch((err) => { });
  };
  const removeMiss = (event, index, code) => {
    const userStr = JSON.parse(localStorage.getItem("users"));
    let fdata = {
      id: event,
      user_id: userStr[0].id,
      code: code,
    };
    axios
      .post("https://jlmining.app/removeNearmiss", fdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        // console.log(res.data.results);

        setOpenDropdownIndexeditMiss(
          index === openDropdownIndexeditMiss ? null : null
        );
        setOpenDropdownIndexMiss(index === openDropdownIndexMiss ? null : null);
        setTimeout(() => {
          setgetnearDataLength(res.data.results.length);

          setgetnearData(res.data.results);
        }, 500);
      })
      .catch((err) => { });
  };
  const searchhazard = (event) => {
    const userStr = JSON.parse(localStorage.getItem("users"));
    let fdata = {
      search: event.value,
      user_id: userStr[0].id,
    };
    //console.log(fdata);
    axios
      .post("https://jlmining.app/hazardreportfiltersite", fdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setisgetallhazardl(res.data.results.length);

        setisgetallhazard(res.data.results);
      })
      .catch((err) => { });
  };
  const filterdate = (event) => {
    const userStr = JSON.parse(localStorage.getItem("users"));
    let fdata = {
      date: event.target.value,
      user_id: userStr[0].id,
    };
    //console.log(fdata);
    axios
      .post("https://jlmining.app/hazardreportfilter", fdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setisgetallhazardl(res.data.results.length);

        setisgetallhazard(res.data.results);
      })
      .catch((err) => { });
  };
  const uploaddoc = () => {
    setIsModalOpenDoc(true);
  };
  const closeDoc = () => {
    if (inputFileRef.current) {
      inputFileRef.current.value = "";
    }
    setfilename("");
    setIsModalOpenDoc(false);
  };
  const docfile = (event) => {
    const file = event.target.files[0]; // Get the first file from the input

    setfilename(file);
  };
  const handleRemoveFile = (event) => {
    if (inputFileRef.current) {
      inputFileRef.current.value = "";
    }
    setfilename("");
  };
  const assigntoall = (event) => {
    //console.log(event.target.checked);
    if (event.target.checked === true) {
      setdiss(true);
    } else {
      setdiss(false);
    }
  };
  const handcategory = (event) => {
    //console.log(event);
    setcategoryvl(event);
  };
  const formdite = (event) => {
    setgetLocationsingle({
      value: event.value,
      label: event.value,
    });
  };
  const handsubmitcategory = (event) => {
    const userStr = JSON.parse(localStorage.getItem("users"));
    var formData = new FormData();
    // console.log(diss);
    if (diss == true) {
      var assign = "Yes";
      var fsite = event.target.form_site.value;
    } else {
      var assign = "No";
      var fsite = "";
    }
    formData.append("category", event.target.category.value);
    formData.append("user_id", userStr[0].id);
    formData.append("file", fileshow);
    formData.append("form_site", fsite);
    formData.append("assign", assign);
    //console.log(formData);
    axios
      .post("https://jlmining.app/documentsave", formData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        setdocs_s(true);
        setTimeout(() => {
          setdocs_s(false);
          setfilename("");
          setcategoryvl("");
          setgetLocationsingle("");
          if (inputFileRef.current) {
            inputFileRef.current.value = "";
          }
          event.target.reset();
          setIsModalOpenDoc(false);
        }, 4500);
      })
      .catch((err) => { });
  };
  const handleDownload = (m, file) => {
    const link = document.createElement("a");
    link.href = file;
    link.download = m;
    link.click();
  };
  const apiurl = "https://jlmining.app/uploads/elearning";
  let currentDate = new Date();
  let year = currentDate.getFullYear();
  let month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Add leading zero if needed
  let day = String(currentDate.getDate()).padStart(2, "0");

  let formattedDate = year + "-" + month + "-" + day;
  //console.log(formattedDate); // Output: 2024-04-11
  const generatedate = (datee) => {
    let currentDate = new Date(datee);
    let year = currentDate.getFullYear();
    let month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Add leading zero if needed
    let day = String(currentDate.getDate()).padStart(2, "0");

    let formattedDate = year + "-" + month + "-" + day;
    return formattedDate;
  };
  const redhref = (event) => {
    window.open("/start-course/" + event);
  };
  const closeBox = () => {
    setopendialog(false);
  };
  const viewcertificate = () => {
    const userStr = JSON.parse(localStorage.getItem("users"));

    let formdata = {
      user_id: userStr[0].id,
    };
    axios
      .post("https://jlmining.app/getCourseComplete", formdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setComplete(res.data.results);
      })
      .catch((err) => { });
    setopendialog(true);
  };
  //Pdf
  function getimagedata(urll) {
    console.log(urll);
    let formdata = {
      url: urll,
    };

    const mainpdf = (
      <html lang="en">
        <head>
          <meta charset="utf-8" />
          <link rel="icon" href="/" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <meta name="theme-color" content="#000000" />
          <meta
            name="description"
            content="Web site created using create-react-app"
          />
          <link
            href="https://fonts.googleapis.com/css2?family=Great+Vibes&family=Quattrocento:wght@400;700&display=swap"
            rel="stylesheet"
          />
        </head>
        <body>
          <table
            style={{
              width: "700px",
              margin: "0 auto",
              border: "10px solid rgb(0, 74, 173)",
            }}
          >
            <tbody style={{ width: "100%" }}>
              <tr>
                <td style={{ textAlign: "center" }}>
                  <div
                    style={{
                      margin: "0 auto",
                      width: "250px",
                    }}
                  >
                    <img style={{ width: "50%" }} src={imgBase64} alt="logo" />
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <h1
                    style={{
                      color: "rgb(0, 74, 173)",
                      fontSize: "35px",
                      textAlign: "center",
                      padding: "0px 0px",
                      fontFamily: '"Quattrocento", serif',
                    }}
                  >
                    Certificate of Training
                  </h1>
                </td>
              </tr>
              <tr>
                <td>
                  <h2
                    style={{
                      color: "#323232",
                      fontWeight: 400,
                      fontSize: "20px",
                      textAlign: "center",
                      padding: "5px 0px",
                      fontFamily: '"Quattrocento", serif',
                    }}
                  >
                    This is to certify that
                  </h2>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <h3
                      style={{
                        color: "#323232",
                        fontWeight: 400,
                        marginTop: "30px",
                        fontSize: "20px",
                        textAlign: "center",
                        padding: "5px 0px",
                        fontFamily: '"Quattrocento", serif',
                      }}
                    >
                      {name_9}
                    </h3>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <h2
                    style={{
                      color: "#323232",
                      fontWeight: 400,
                      marginTop: "30px",
                      fontSize: "20px",
                      textAlign: "center",
                      padding: "5px 0px",
                      fontFamily: '"Quattrocento", serif',
                    }}
                  >
                    has successfully completed training in
                  </h2>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <h3
                      style={{
                        color: "#000",
                        fontWeight: 400,
                        fontSize: "20px",
                        textAlign: "center",
                        margin: "12px 0px",
                        fontFamily: '"Quattrocento", serif',
                      }}
                    >
                      {pdfname}
                    </h3>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div
                    style={{
                      padding: "10px 0px",
                      marginTop: "15px",
                    }}
                  >
                    <h5
                      style={{
                        color: "#000",
                        fontWeight: 400,
                        fontSize: "20px",
                        textAlign: "center",
                        margin: "0px 0px",
                        fontFamily: '"Quattrocento", serif',
                      }}
                    >
                      undertaken on the date
                    </h5>
                    <h6
                      style={{
                        color: "#000",
                        fontWeight: 400,
                        fontSize: "20px",
                        textAlign: "center",
                        margin: "0px 0px",
                        fontFamily: '"Quattrocento", serif',
                      }}
                    >
                      {formatDate_notes(pdfdate)}
                    </h6>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <h2
                    style={{
                      color: "#323232",
                      fontWeight: 400,
                      fontSize: "20px",
                      textAlign: "center",
                      paddingTop: "40px",
                      fontFamily: '"Quattrocento", serif',
                    }}
                  >
                    Delivered by:
                  </h2>
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>
                  <div
                    style={{
                      margin: "0 auto",
                      width: "250px",
                      paddingBottom: "10px",
                    }}
                  >
                    <img style={{ width: "50%" }} src={imgBase64} alt="logo" />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </body>
      </html>
    );
    const filenamee = pdfname;
    console.log("sdd");
    setTimeout(() => {
      generatePDF(mainpdf, filenamee);
    }, 600);
  }
  const pdfdataget = async () => {
    const cc = await getimagedata("logo1.png");
  };
  const downloadpdf = (name, cname, date) => {
    setname_9(cname);
    setpdfname(name);
    setscoreCard(1);
    setpdfdate(date);
  };
  //Pdf

  return (
    <>
      <style>
        {`
        ._Xt-75 {
          z-index:99;
        }
        @media only screen and (max-width: 768px){
          ._Xt-75{
            width:89% !important;
          }
        }
      `}
      </style>
      <HeaderHome />
      <section className="d-block py-5">
        <div className="container-lg">
          <div className="row justify-content-center">
            <div className="col-lg-5">
              <div className="d-flex flex-column por-tesk">
                <div className="d-flex flex-column gap-1 title-box pt-3 pb-5 px-3">
                  <h2>Your tasks...</h2>
                  <h6>Over the next 10 days</h6>
                </div>
                <div className="d-flex justify-content-center probar">
                  <div className="circle-big">
                    <div className="text">{courseUpcoming}</div>
                    <svg>
                      <circle className="bg" cx="57" cy="57" r="50"></circle>
                      <circle
                        style={{ strokeDasharray: strokeDashArray_less }}
                        className="progress"
                        cx="57"
                        cy="57"
                        r="50"
                      ></circle>
                    </svg>
                  </div>
                </div>
                <div className="overdue px-4 pb-4 d-flex flex-column gap-3">
                  <div className="d-flex gap-2">
                    <div className="flex-shrink-0">
                      <i className="fal fa-exclamation-triangle"></i>
                    </div>
                    <div className="flex-grow-1">
                      <h4>Overdue ({courseUpcoming})</h4>
                    </div>
                  </div>

                  <div className="d-flex gap-2">
                    <div className="flex-shrink-0">
                      <i className="fal fa-clock"></i>
                    </div>
                    <div className="flex-grow-1">
                      {courseComplete ? (
                        <Link
                          to="#"
                          onClick={() => viewcertificate()}
                          className="fs-5"
                        >
                          The course completion certificate ({courseComplete})
                        </Link>
                      ) : (
                        <Link to="#" className="fs-5">
                          The course completion certificate ({courseComplete})
                        </Link>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {opendialog && (
        <ReactDialogBox
          closeBox={closeBox}
          modalWidth="40%"
          headerBackgroundColor="red"
          headerTextColor="white"
          headerHeight="50"
          closeButtonColor="white"
          bodyBackgroundColor="white"
          bodyTextColor="black"
          bodyHeight="300px"
          headerText="Course Completion Certificate"
        >
          <div style={{ height: "200px", overflowY: "scroll" }}>
            <div className="d-flex flex-column gap-3 bg-white shadow  p-4 inperson">
              <h3 className="mt-4"></h3>
              <div className="d-flex flex-column gap-2">
                {Array.isArray(isComplete) ? (
                  isComplete.map((item, index) => (
                    <Link
                      to="javascript:void(0)"
                      onClick={() =>
                        downloadpdf(item.name, item.cname, item.date)
                      }
                    >
                      {item.name} <FaFilePdf />
                    </Link>
                  ))
                ) : (
                  <Link> No data available </Link>
                )}
              </div>
            </div>
          </div>
        </ReactDialogBox>
      )}
      <section className="d-block pb-5">
        <div className="container-lg">
          <div className="d-flex flex-column gap-3">
            <div className="d-flex flex-column gap-1 notif-content">
              <h2>Assign to me</h2>
              {/* <p className="p-2 gap-2">
                This is a list of all the courses that have been specifically
                assigned for you to complete by your learning manager
              </p> */}
              <div className="d-flex flex-md-row flex-column  gap-2 ">
                {Array.isArray(courseUpcomingd) &&
                  courseUpcomingd.length > 0 ? (
                  courseUpcomingd
                    .filter((item) => item && item.name) // Ensure item is not null/undefined and has a name
                    .map((item, index) => (
                      <Link
                        key={item.unique_code || index} // Use a unique key
                        onClick={() => redhref(item.unique_code)}
                        to="javascript:void(0)"
                        className="gap-2 mt-3 text-dark ss"
                      >
                        <br />
                        <br />
                        <span className="fw-800 text-danger">
                          ({index + 1}). {item.name}
                        </span>{" "}
                        course due date is{" "}
                        <span className="fw-800 text-danger">
                          {formatDate_date(item.assign_date)}
                        </span>
                      </Link>
                    ))
                ) : (
                  <Link> No data available </Link>
                )}
              </div>
            </div>
            <div className="d-flex flex-column gap-1 notif-content">
              <h3>Action Center</h3>
              <p>
                In this action center, you can file or report incidents, near
                misses, and hazards. Additionally, you can view documents, take
                courses, and obtain certificates.
              </p>
            </div>
            <div className="row gy-3">
              <div className="d-flex flex-md-row flex-column justify-content-between gap-3">
                <div className="">
                  <Link
                    to="/incident"
                    className="d-flex flex-column gap-1 report-box"
                  >
                    <h2>Incidents</h2>
                    <p>
                      Click on this tab to report an incident by providing brief
                      details.
                    </p>
                  </Link>
                </div>
                <div className="">
                  <Link
                    to="/near-miss/detail"
                    className="d-flex flex-column gap-1 report-box"
                  >
                    <h2>Near Misses</h2>
                    <p>
                      Click on this tab to report near misses with brief
                      details.
                    </p>
                  </Link>
                </div>
                <div className="">
                  <Link
                    to="/reporthazard"
                    className="d-flex flex-column gap-1 report-box"
                  >
                    <h2>Report a hazard</h2>
                    <p>
                      Click on this tab to submit a hazard report, detailing the
                      issue
                    </p>
                  </Link>
                </div>
                <div className="">
                  <Link
                    to="/documents"
                    className="d-flex flex-column gap-1 report-box"
                  >
                    <h2>Documents</h2>
                    <p>
                      By clicking this option, access and view documents
                      conveniently.
                    </p>
                  </Link>
                </div>
                <div className="">
                  <Link
                    to="/e-learninghub"
                    className="d-flex flex-column gap-1 report-box"
                  >
                    <h2>E-Learning</h2>
                    <p>
                      Open this tab to view the available courses, including
                      overdue ones and courses assigned to you.
                    </p>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="d-block pb-5">
        <div className="container-lg">
          <div className="row">
            <div className="col-12">
              <ul className="nav nav-tabs inci-tab" id="myTab" role="tablist">
                {/* <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${
                      activeTab === "home-tab" ? "active" : ""
                    }`}
                    id="home-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#home-tab-pane"
                    type="button"
                    role="tab"
                    aria-controls="home-tab-pane"
                    aria-selected="true"
                  >
                    Incidents
                  </button>
                </li> */}
                {/* <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${
                      activeTab === "profile-tab" ? "active" : ""
                    }`}
                    id="profile-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#profile-tab-pane"
                    type="button"
                    role="tab"
                    aria-controls="profile-tab-pane"
                    aria-selected="false"
                  >
                    Near Misses
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${
                      activeTab === "report-tab" ? "active" : ""
                    }`}
                    id="report-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#report-tab-pane"
                    type="button"
                    role="tab"
                    aria-controls="report-tab-pane"
                    aria-selected="false"
                  >
                    Report a hazard
                  </button>
                </li> */}
              </ul>
              <div className="tab-content" id="myTabContent">
                {/* <div
                  className="tab-pane fade show active p-3 border border-secondary border-opacity-25"
                  id="home-tab-pane"
                  role="tabpanel"
                  aria-labelledby="home-tab"
                  tabindex="0"
                >
                  <div className="d-flex flex-column gap-4">
                    <div className="d-flex flex-column flex-md-row gap-2 justify-content-between">
                      <div className="d-flex gap-2 align-items-center number-siz-title"></div>
                      <div>
                        <Link to="/incident" className="cbtn">
                          Create <i className="fal fa-plus"></i>
                        </Link>
                      </div>
                    </div>

                    <div id="mid-open" className="row gap-3">
                      <div className="open col-12">
                        <div className="d-flex gap-3 align-items-center">
                          <i className="fal fa-ellipsis-v"></i>
                          <p>Open</p>
                          <div className="six">
                            <p>{getincidentDataLength}</p>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        {Array.isArray(getincidentData) ? (
                          getincidentData.map((item, index) => (
                            <div className="col-lg-6 mt-2">
                              <div className="test position-relative">
                                <div className="d-flex justify-content-between">
                                  <div className="d-flex flex-column gap-3">
                                    {item.status !== "Closed" && (
                                      <Link
                                        to={`/incident/about/${item.unique_code}`}
                                      >
                                        {item.reference}
                                      </Link>
                                    )}
                                    {item.status === "Closed" && (
                                      <h6>{item.reference}</h6>
                                    )}
                                    <div className="d-flex flex-column gap-2 test-info">
                                      <p>{item.site_step4}</p>
                                      <p>{item.locations}</p>
                                      <p>
                                        <strong>Status:</strong> {item.status}
                                      </p>
                                      <p>
                                        Date:{" "}
                                        {item.step4_date
                                          ? getdattime(item.step4_date)
                                          : ""}
                                      </p>
                                    </div>
                                  </div>
                                  {item.status !== "Closed" && (
                                    <div className="pop-up">
                                      <button
                                        className="btn dropdown-toggle"
                                        type="button"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                        onClick={() => incidentedit(index)}
                                      >
                                        <i className="fal fa-ellipsis-v"></i>
                                      </button>

                                      <ul
                                        className={`dropdown-menu ${
                                          openDropdownIndexIncident === index
                                            ? "show"
                                            : ""
                                        } dropdown-menu-end p-0`}
                                      >
                                        <li>
                                          <Link
                                            className="dropdown-item"
                                            style={{ fontSize: "12px" }}
                                            to={`/incident/about/${item.unique_code}`}
                                          >
                                            <i className="fal fa-edit"></i> Edit
                                          </Link>
                                        </li>
                                        <li>
                                          <Link
                                            className="dropdown-item text-danger"
                                            style={{ fontSize: "13px" }}
                                            to="javascript:void(0)"
                                            onClick={() =>
                                              removeIncident(
                                                item.id,
                                                index,
                                                item.unique_code
                                              )
                                            }
                                          >
                                            <i className="fal fa-trash-alt"></i>{" "}
                                            Delete
                                          </Link>
                                        </li>
                                      </ul>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <Link> No data available </Link>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade p-3 border border-secondary border-opacity-25"
                  id="profile-tab-pane"
                  role="tabpanel"
                  aria-labelledby="profile-tab"
                  tabindex="0"
                >
                  <div className="d-flex flex-column gap-4">
                    <div className="d-flex flex-column flex-md-row gap-2 justify-content-between">
                      <div className="d-flex gap-2 align-items-center number-siz-title">
                        <div className="flex-grow-1"></div>
                      </div>
                      <div>
                        <Link to="/near-miss/detail" className="cbtn">
                          Create <i className="fal fa-plus"></i>
                        </Link>
                      </div>
                    </div>

                    <div id="mid-open" className="row gap-3">
                      <div className="open col-12">
                        <div className="d-flex gap-3 align-items-center">
                          <i className="fal fa-ellipsis-v"></i>
                          <p>Open</p>
                          <div className="six">
                            <p>{getnearDataLength}</p>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        {Array.isArray(getneartData) ? (
                          getneartData.map((item, index) => (
                            <div className="col-lg-6 mt-2">
                              <div className="test position-relative">
                                <div className="d-flex justify-content-between">
                                  <div className="d-flex flex-column gap-3">
                                    {item.status !== "Closed" && (
                                      <Link
                                        to={`/near-miss/detail/${item.unique_code}`}
                                      >
                                        {item.reference}
                                      </Link>
                                    )}
                                    {item.status === "Closed" && (
                                      <h6>{item.reference}</h6>
                                    )}
                                    <div className="d-flex flex-column gap-2 test-info">
                                      <p>{item.site_step4}</p>
                                      <p>{item.locations}</p>
                                      <p>
                                        <strong>Status:</strong> {item.status}
                                      </p>
                                      <p>
                                        Date:{" "}
                                        {item.step4_date
                                          ? getdattime(item.step4_date)
                                          : ""}
                                      </p>
                                    </div>
                                  </div>
                                  {item.status !== "Closed" && (
                                    <div className="pop-up">
                                      <button
                                        className="btn dropdown-toggle"
                                        type="button"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                        onClick={() => nearmissedit(index)}
                                      >
                                        <i className="fal fa-ellipsis-v"></i>
                                      </button>

                                      <ul
                                        className={`dropdown-menu ${
                                          openDropdownIndexMiss === index
                                            ? "show"
                                            : ""
                                        } dropdown-menu-end p-0`}
                                      >
                                        <li>
                                          <Link
                                            className="dropdown-item"
                                            style={{ fontSize: "12px" }}
                                            to={`/near-miss/detail/${item.unique_code}`}
                                          >
                                            <i className="fal fa-edit"></i> Edit
                                          </Link>
                                        </li>
                                        <li>
                                          <Link
                                            className="dropdown-item text-danger"
                                            style={{ fontSize: "13px" }}
                                            to="javascript:void(0)"
                                            onClick={() =>
                                              removeMiss(
                                                item.id,
                                                index,
                                                item.unique_code
                                              )
                                            }
                                          >
                                            <i className="fal fa-trash-alt"></i>{" "}
                                            Delete
                                          </Link>
                                        </li>
                                      </ul>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <Link> No data available </Link>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade p-3 border border-secondary border-opacity-25"
                  id="report-tab-pane"
                  role="tabpanel"
                  aria-labelledby="report-tab"
                  tabindex="0"
                >
                  <div className="d-flex flex-column gap-4">
                    <div className="d-flex flex-column flex-md-row gap-2 justify-content-between">
                      <div className="d-flex gap-2 align-items-center number-siz-title">
                        <div className="flex-grow-1"></div>
                      </div>
                      <div>
                        <Link to="/reporthazard" className="cbtn">
                          Create <i className="fal fa-plus"></i>
                        </Link>
                      </div>
                    </div>

                    <div className="top-input d-flex gap-3">
                      <div className="site">
                        <p>Site</p>

                        <Select
                          required
                          options={issetgetLocations}
                          name="hazard_site"
                          onChange={searchhazard}
                          id="site"
                        />
                      </div>
                      <div className="date">
                        <p>Date created</p>
                        <input type="date" onChange={filterdate} id="date" />
                      </div>
                    </div>
                    <div id="mid-open" className="row gap-3">
                      <div className="open col-12">
                        <div className="d-flex gap-3 align-items-center">
                          <i className="fal fa-ellipsis-v"></i>
                          <p>Open</p>
                          <div className="six">
                            <p>{isgetallhazardl}</p>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        {Array.isArray(isgetallhazard) ? (
                          isgetallhazard.map((item, index) => (
                            <div className="col-lg-6 mt-2">
                              <div className="test position-relative">
                                <div className="d-flex justify-content-between">
                                  <div className="d-flex flex-column gap-3">
                                    <Link
                                      to={`/reporthazard/edit/${item.unique_code}`}
                                    >
                                      {item.name}
                                    </Link>
                                    <div className="d-flex flex-column gap-2 test-info">
                                      <p>
                                        <strong>Site:</strong>{" "}
                                        {item.hazard_site}
                                      </p>
                                      <p>
                                        <strong>Created date:</strong>{" "}
                                        {formatDate_notes(item.created_at)}
                                      </p>
                                      <p>
                                        <strong>Reporter:</strong>{" "}
                                        {item.reporter}
                                      </p>
                                      <p>
                                        <strong>Owner:</strong> Unassigned
                                      </p>
                                    </div>
                                  </div>
                                  <div className="pop-up">
                                    <button
                                      className="btn dropdown-toggle"
                                      type="button"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                      onClick={() => hazardedit(index)}
                                    >
                                      <i className="fal fa-ellipsis-v"></i>
                                    </button>

                                    <ul
                                      className={`dropdown-menu ${
                                        openDropdownIndex === index
                                          ? "show"
                                          : ""
                                      } dropdown-menu-end p-0`}
                                    >
                                      <li>
                                        <Link
                                          className="dropdown-item"
                                          style={{ fontSize: "12px" }}
                                          to={`/reporthazard/edit/${item.unique_code}`}
                                        >
                                          <i className="fal fa-edit"></i> Edit
                                        </Link>
                                      </li>
                                      <li>
                                        <Link
                                          className="dropdown-item text-danger"
                                          style={{ fontSize: "13px" }}
                                          to="javascript:void(0)"
                                          onClick={() =>
                                            remover(
                                              item.id,
                                              index,
                                              item.unique_code
                                            )
                                          }
                                        >
                                          <i className="fal fa-trash-alt"></i>{" "}
                                          Delete
                                        </Link>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <Link> No data available </Link>
                        )}
                      </div>
                    </div>
                  </div>
                </div> */}

                <div
                  className="tab-pane fade p-3 border border-secondary border-opacity-25"
                  id="document-tab-pane"
                  role="tabpanel"
                  aria-labelledby="document-tab"
                  tabindex="0"
                >
                  <div className="d-flex flex-column gap-4">
                    <div className="d-flex flex-column flex-md-row gap-2 justify-content-between">
                      <div className="d-flex gap-2 align-items-center number-siz-title">
                        {/* <div className="flex-shrink-0">
                          <div className="num-six">
                            <div className="circle-small">
                              <div className="text">
                                {getincidentDataLength}
                                <br />
                              </div>
                            </div>
                          </div>
                        </div> */}
                        <div className="flex-grow-1"></div>
                      </div>
                      {/* <div>
                        <Link
                          to="javascript:void(0)"
                          onClick={uploaddoc}
                          className="cbtn"
                        >
                          Upload Document <i className="fal fa-plus"></i>
                        </Link>
                      </div> */}
                      <Modal
                        isOpen={isModalOpenDoc}
                        onRequestClose={() => setIsModalOpenDoc(false)}
                        contentLabel="Add Text Modal"
                        className="docs d-flex flex-column  bg-light mt-5 p-3 align-item-center justify-content-center"
                      >
                        <div style={{ width: "500px" }}>
                          <div className="d-flex flex-column file-pop">
                            <div className="d-flex justify-content-between align-items-center top-head">
                              <div className="flex-grow-1">
                                <h2>Upload</h2>
                              </div>
                              <div className="flex-shirnk-0">
                                <button
                                  type="button"
                                  onClick={() => closeDoc()}
                                  className="close-btn"
                                >
                                  <i
                                    className="fal fa-times"
                                    aria-hidden="true"
                                  ></i>
                                </button>
                              </div>
                            </div>
                            <div className="d-flex flex-column px-1 py-2">
                              <h3 className="text-black choose-text">
                                Choose thsssse document you would like to
                                upload.
                              </h3>
                              {fileshow && (
                                <div className="sceenshot-box my-1 d-flex align-items-center border-secondary border border-opacity-25 bg-secondary bg-opacity-25 py-1 px-3">
                                  <div className="flex-grow-1">
                                    <h4>{fileshow.name}</h4>{" "}
                                    {/* Display the file name */}
                                  </div>
                                  <div className="flex-shrink-0">
                                    <button
                                      type="button"
                                      className="scsbtn"
                                      onClick={() => handleRemoveFile()}
                                    >
                                      <i className="fal fa-trash-alt"></i>{" "}
                                      {/* Button to remove the file */}
                                    </button>
                                  </div>
                                </div>
                              )}
                              <form
                                action="javascript:void(0)"
                                method="post"
                                onSubmit={handsubmitcategory}
                              >
                                <div className="d-flex flex-column text-center gap-3 rel p-4 drop-box-pop mx-auto ">
                                  <i className="fal fa-arrow-alt-up"></i>
                                  <h1>
                                    Drag and drop your files here to upload
                                  </h1>
                                  <h6>Browse files...</h6>
                                  <input
                                    type="file"
                                    multiple
                                    onChange={docfile}
                                    ref={inputFileRef}
                                    className="file-name-block"
                                  />
                                </div>
                                <div class="d-flex flex-column gap-3 drag-box">
                                  <div class="d-flex flex-column gap-1">
                                    <label for="">Category</label>
                                    <Select
                                      options={docscategory}
                                      value={iscategoryvl}
                                      name="category"
                                      onChange={handcategory}
                                    />
                                  </div>
                                  <div class="d-flex flex-column gap-1">
                                    <label for="">Site</label>
                                    <Select
                                      required={diss ? false : true}
                                      disabled={diss}
                                      options={issetgetLocations}
                                      name="form_site"
                                      value={issetgetLocationsingle}
                                      onChange={formdite}
                                      className={` ${diss === true ? "sitesdocs" : ""
                                        } `}
                                    />
                                  </div>
                                  <div class="d-flex gap-2 check-box-list">
                                    <div class="flex-shrink-0">
                                      <input
                                        type="checkbox"
                                        name="assign"
                                        onChange={assigntoall}
                                      />
                                    </div>
                                    <div class="flex-grow-1">
                                      <h6>Assign to all sites</h6>
                                    </div>
                                  </div>
                                </div>
                                {docs_s && (
                                  <span class="text-success">
                                    Document has been successfully saved
                                  </span>
                                )}
                                <div className="d-flex flex-column gap-3 drag-box">
                                  <div className="d-flex gap-2 check-box-list">
                                    <div className="d-flex gap-2 align-items-center justify-content-end btns-box mt-4">
                                      <div className="flex-shrink-0">
                                        <button
                                          type="button"
                                          onClick={() => closeDoc()}
                                        >
                                          Cancel
                                        </button>
                                      </div>
                                      <div className="flex-shrink-0">
                                        <button type="submit">Upload</button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </Modal>
                    </div>
                    <div className="d-flex flex-column gap-2 align-items-start number-siz-title">
                      <table className="table tableprimary doctable">
                        <thead>
                          <th>Title</th>
                          <th>Category</th>
                          <th>Sites</th>
                          <th>Date Created</th>
                        </thead>
                        <tbody className="trbody">
                          {Array.isArray(issetgetalldocuments) ? (
                            issetgetalldocuments.map((item, index) => (
                              <tr className="even">
                                <td>
                                  <Link
                                    to="javascript:void(0)"
                                    onClick={() =>
                                      handleDownload(
                                        item.file,
                                        `https://jlmining.app/uploads/documents/${item.file}`
                                      )
                                    }
                                  >
                                    {item.file}
                                  </Link>
                                </td>
                                <td>{item.category}</td>
                                <td>
                                  {item.assign_to === "Yes" ? "All" : item.site}
                                </td>
                                <td>{formatDate_notes(item.created_at)}</td>
                              </tr>
                            ))
                          ) : (
                            <div> No data available </div>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};
